import { AxiosInstance } from 'axios';
import config from 'config/Config';
import get from 'lodash/get';
import { initAxios } from 'utils/axios';

class AccountsAPI {
  instance: AxiosInstance;

  constructor() {
    this.instance = initAxios(config.get('backendURL'));
  }

  getEnterpriseConnection: (accountId: string) => Promise<string> = async (
    accountId
  ) => {
    const response = await this.instance.get(
      `/enterpriseConnections/${accountId}`
    );
    return get(response, 'data.connectionId');
  };

  getEnterpriseConnectionByDomain: (domain: string) => Promise<object> = async (
    domain
  ) => {
    const response = await this.instance.get(
      `/enterpriseConnections/byDomain/${domain}`
    );
    return response.data;
  };
}

const accountsAPI = new AccountsAPI();

export default accountsAPI;
